import React from 'react';
import './DeletePopup.scss';
import PopUp from "../PopUp/PopUp";

const DeletePopup = ({name, active, deleteClick, cancelClick}) => {
  return (
    <PopUp active={active}>
      <div className="DeletePopup">
        <p className="modal-eyebrow">Confirmar exclusao</p>
        <h2>Tem certeza que deseja remover {name}?</h2>
        <p className="modal-description">
          Essa acao remove o acesso dessa pessoa da listagem atual. Voce pode convidar novamente depois, se precisar.
        </p>
        <div className="buttons-popup">
          <button type="button" className="popup-btn secondary" onClick={cancelClick}>Cancelar</button>
          <button type="button" className="popup-btn danger" onClick={deleteClick}>Remover</button>
        </div>
      </div>
    </PopUp>
  );
};

export default DeletePopup;
